var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { DOCUMENT_FILES, ICON_FILES } from './constants';
export var checkImageDimensions = function (file) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function (event) {
            var _a;
            var img = new Image();
            img.onload = function () {
                var width = img.width, height = img.height;
                // Check if width and height are less than 1300 & greater than 800
                if (width < 1300 && width > 800 && height > 800 && height < 1300) {
                    resolve(true);
                }
                else {
                    resolve(false);
                }
            };
            img.onerror = function () {
                reject(new Error('Failed to load image.'));
            };
            if ((_a = event.target) === null || _a === void 0 ? void 0 : _a.result) {
                img.src = String(event.target.result);
            }
        };
        reader.readAsDataURL(file);
    });
};
export var checkMultipleImagesDimensions = function (valueArray) { return __awaiter(void 0, void 0, void 0, function () {
    var results, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, Promise.all(valueArray.map(function (file) {
                        return file.type === DOCUMENT_FILES ||
                            file.type === ICON_FILES ||
                            checkImageDimensions(file);
                    }))];
            case 1:
                results = _a.sent();
                return [2 /*return*/, results.every(function (res) { return res; })];
            case 2:
                error_1 = _a.sent();
                console.error('Error processing files:', error_1);
                throw error_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
export var hasAlpha = function (file) {
    return new Promise(function (resolve, reject) {
        var img = new Image();
        // create image from file
        img.src = URL.createObjectURL(file);
        img.onerror = reject;
        img.onload = function () {
            // create canvas
            var canvas = document.createElement('canvas');
            var ctx = canvas.getContext('2d');
            canvas.width = img.width;
            canvas.height = img.height;
            ctx === null || ctx === void 0 ? void 0 : ctx.drawImage(img, 0, 0);
            // get image data
            var data = ctx === null || ctx === void 0 ? void 0 : ctx.getImageData(0, 0, canvas.width, canvas.height);
            var dataArray = (data === null || data === void 0 ? void 0 : data.data) || [];
            // check if image has any transparent background
            var hasTransparent = __spreadArray([], dataArray, true).some(function (value, index) {
                return index % 4 === 3 && value < 255;
            });
            return hasTransparent ? resolve(true) : resolve(false);
        };
    });
};
export var checkMultipleImagesHasAlpha = function (valueArray) { return __awaiter(void 0, void 0, void 0, function () {
    var results, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, Promise.all(valueArray.map(function (file) {
                        return file.type === DOCUMENT_FILES ||
                            file.type === ICON_FILES ||
                            hasAlpha(file);
                    }))];
            case 1:
                results = _a.sent();
                return [2 /*return*/, results.every(function (res) { return res; })];
            case 2:
                error_2 = _a.sent();
                console.error('Error processing files:', error_2);
                throw error_2;
            case 3: return [2 /*return*/];
        }
    });
}); };
